import { Spin } from 'antd';

import type { FC } from 'react';

import '@pages/Branches/AddBranch/styles/AdditionalTabSavingOverlay.scss';

interface AdditionalTabSavingOverlayProps {
  tip?: string;
}

export const AdditionalTabSavingOverlay: FC<
  AdditionalTabSavingOverlayProps
> = ({ tip = 'Сохранение…' }) => {
  return (
    <div
      className="AdditionalTabSavingOverlay"
      role="status"
      aria-live="polite"
    >
      <div className="AdditionalTabSavingOverlay__spinner">
        <Spin size="default" tip={tip} />
      </div>
    </div>
  );
};
